export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export function formatCurrencyFromMinor(valueMinor: number): string {
  return formatCurrency(valueMinor / 100)
}
